/* MTD Reviews — arrow controls over a native scroll-snap track. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.mtdReady === 'true') return;
    root.dataset.mtdReady = 'true';

    var track = root.querySelector('[data-mtd-track]');
    var prev = root.querySelector('[data-mtd-prev]');
    var next = root.querySelector('[data-mtd-next]');
    var slide = root.querySelector('[data-mtd-slide]');
    if (!track || !prev || !next || !slide) return;

    function step() {
      var gap = parseFloat(getComputedStyle(track.firstElementChild).gap) || 20;
      return slide.getBoundingClientRect().width + gap;
    }

    function scrollBy(direction) {
      track.scrollBy({ left: direction * step(), behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { scrollBy(-1); });
    next.addEventListener('click', function () { scrollBy(1); });

    var nav = prev.parentElement;

    function sync() {
      var max = track.scrollWidth - track.clientWidth;

      // Cards all fit — there is nothing to page through.
      if (max <= 1) {
        if (nav) nav.hidden = true;
        return;
      }
      if (nav) nav.hidden = false;

      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    }

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    // Card widths depend on fonts, so re-measure once they settle.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    sync();

    /* ---------- Autoplay ---------- */
    var wantsAutoplay = root.dataset.autoplay === 'true';
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!wantsAutoplay || calm.matches) return;

    var delay = (parseFloat(root.dataset.autoplaySpeed) || 5) * 1000;
    var timer = null;
    var stopped = false;

    function advance() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 1) return;
      // Loop back to the start once the last card is reached.
      if (track.scrollLeft >= max - 2) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        scrollBy(1);
      }
    }

    function start() {
      if (stopped || timer) return;
      timer = setInterval(advance, delay);
    }

    function pause() {
      clearInterval(timer);
      timer = null;
    }

    // Any deliberate interaction ends autoplay for good — resuming under
    // someone's fingers is worse than simply stopping.
    function stopForGood() {
      stopped = true;
      pause();
    }

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', pause);
    track.addEventListener('pointerdown', stopForGood);
    track.addEventListener('wheel', stopForGood, { passive: true });
    prev.addEventListener('click', stopForGood);
    next.addEventListener('click', stopForGood);

    // Don't animate a carousel nobody is looking at.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? start() : pause(); });
      }, { threshold: 0.2 }).observe(root);
    } else {
      start();
    }

    document.addEventListener('visibilitychange', function () {
      document.hidden ? pause() : start();
    });
  }

  function boot() {
    document.querySelectorAll('[data-mtd-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-mtd-reviews]').forEach(init);
  });
})();
